<template>
  <div>
    <div class="public-table-but__left">
      <div class="item">
        <!-- <em>筛选：</em> -->
        <div class="item-wp">
          <template v-if="searchShow">
            <div class="item-son">
              <el-input
                  v-model="listParams.searchKey"
                  clearable
                  @keyup.enter.native="SearchCompanyList"
                  placeholder="搜索关键词"
              ></el-input>
            </div>
            <div class="item-son">
              <el-select
                  v-model="listParams.status"
                  clearable
                  filterable
                  placeholder="请选择"
                  style="width: 100px"
              >
                <el-option label="存续" value="1"></el-option>
                <el-option label="停业" value="2"></el-option>
                <el-option label="注销" value="3"></el-option>
              </el-select>
            </div>
            <div class="item-son">
              <el-button  type="primary" @click="SearchCompanyList"
              >查询 <i class="el-icon-search"></i>
              </el-button>
            </div>
          </template>

          <div class="item-son" v-if="addShow">
            <el-button  type="primary" @click="handleClick('add')"
              >新增 <img src="@assets/images/add-icon.png" alt="" />
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="public-table-data">
      <el-table
        ref="multipleTable"
        size="medium"
        :data="tableData"
        border
        style="width: 100%"
        row-key="menuId"
        v-loading="loading"
        :tree-props="{ children: 'menus' }"
      >
        <!-- <el-table-column type="selection" width="50" align="center">
        </el-table-column> -->
       <el-table-column
              align="center"
              fixed
              label="序号"
              type="index"
              width="100"
            >
              <template slot-scope="scope">
                <span>{{
                  (pages.pageNo - 1) * pages.pageSize + scope.$index + 1
                }}</span>
              </template>
            </el-table-column>
        <el-table-column prop="name" label="简称" min-width="160" align="center">
        </el-table-column>
        <el-table-column
          prop="fullName"
          label="全称"
          min-width="200"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="code" label="代码" width="200" align="center">
        </el-table-column>
        <el-table-column
          prop="setupTime"
          label="成立时间"
          min-width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="provinceName"
          label="注册地"
          min-width="220"
          align="center"
        >
          <template slot-scope="scope">
            {{ emptyShow(scope.row.provinceName) +  emptyShow(scope.row.cityName) + emptyShow( scope.row.areaName )  + emptyShow( scope.row.street ) }}
          </template>
        </el-table-column>
        <el-table-column prop="code" label="状态" width="100" align="center">
          <template slot-scope="scope">
            {{ emptyShow(scope.row.status) | status }}
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" fixed="right" min-width="200">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleClick('edit', scope.row)"
              type="warning"
              plain
              v-if="editShow"
              >编辑</el-button
            >
            <el-button
              size="mini"
              @click="handleDelete(scope.row)"
              type="primary"
              plain
              v-if="deleteShow"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="public-pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pages.pageNo"
          :page-sizes="[PAGE_SIZE, 50, 100, 200, 400]"
          :page-size="pages.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 编辑弹框 -->
    <el-dialog
      title="公司信息"
      :visible.sync="dialogVisible"
      width="660px"
      :close-on-click-modal="false"
      class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
          ref="ruleForm"
          :rules="rules"
          :model="params"
          label-width="80px"
        >
          <el-form-item label="简称" prop="name">
            <el-input
              placeholder="请填写公司简称"
              v-model="params.name"
            ></el-input>
          </el-form-item>

          <el-form-item label="全称" prop="fullName">
            <el-input
              placeholder="请填写公司全称"
              v-model="params.fullName"
            ></el-input>
          </el-form-item>

          <el-form-item label="代码" prop="code">
            <el-input
              placeholder="请填写公司代码"
              v-model="params.code"
            ></el-input>
          </el-form-item>

          <el-form-item prop="setupTime" label="成立时间">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="params.setupTime"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>

          <el-form-item prop="status" label="状态">
            <el-select
              v-model="params.status"
              clearable
              filterable
              placeholder="请选择"
              style="width: 100%"
              @change="changeStatus"
            >
              <el-option label="存续" :value="1"></el-option>
              <el-option label="停业" :value="2"></el-option>
              <el-option label="注销" :value="3"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="注册地" required>
            <el-col :span="8">
              <el-form-item prop="province">
                <el-select
                    filterable
                    v-model="params.province"
                  placeholder="请选择省"
                  style=" margin-right: 5px"
                  @change="changeProvince"
                >
                  <el-option
                    v-for="item in provinceList"
                    :key="item.provinceId"
                    :label="item.provinceName"
                    :value="item.provinceId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="city">
                <el-select
                    filterable
                    v-model="params.city"
                  placeholder="请选择市"
                  style="margin-right: 5px"
                  @change="changeCity"
                >
                  <el-option
                    v-for="item in cityList"
                    :key="item.cityId"
                    :label="item.cityName"
                    :value="item.cityId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="area">
                <el-select
                    filterable
                    v-model="params.area"
                  placeholder="请选择区"
                  @change="changeArea"
                >
                  <el-option
                    v-for="item in areaList"
                    :key="item.areaId"
                    :label="item.areaName"
                    :value="item.areaId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="" prop="street">
            <el-input
              placeholder="请填写详细地址"
              v-model="params.street"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
          >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
          >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { PAGE_SIZE, FILE_ROOT, JOB_STATUS } from "@config";

import { isEmpty,emptyShow } from "../../utils/tools";

export default {
  filters: {
    status(num) {
      switch (num) {
        case 1:
          return "存续";
        case 2:
          return "停业";
        case 3:
          return "注销";
      }
    },
  },
  data() {
    return {
      PAGE_SIZE,emptyShow,isEmpty,
      loading:false,
      listParams: {},
      tableData: [],
      params: {},
      dialogVisible: false,
      clickType: "",
      provinceList: [], //省数据
      cityList: [], //市数据
      areaList: [], //区数据
      place: {},
      total: 0,

      pages: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      rules: {
        name: [
          { required: true, message: "请填写公司简称", trigger: "change" },
        ],
        fullName: [
          { required: true, message: "请填写公司全称", trigger: "change" },
        ],
        code: [
          { required: true, message: "请填写公司代码", trigger: "change" },
        ],
        setupTime: [
          { required: true, message: "请选择成立时间", trigger: "change" },
        ],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
        province: [
          { required: true, message: "请选择省份", trigger: "blur" },
        ],
        city: [
          { required: true, message: "请选择市区", trigger: "blur" },
        ],
        area: [
          { required: true, message: "请选择区域", trigger: "blur" },
        ],
      },
      addShow: false,
      deleteShow: false,
      editShow: false,
      searchShow: false,
    };
  },
  created() {
    this.queryTableData();
    this.provinceIdData();
    this.getPermissionButtonList()
  },

  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
      }
    },
  },

  methods: {
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'company:manage:query') {
            this.searchShow = true
          }
          if (item.code == 'company:manage:add') {
            this.addShow = true
          }
          if (item.code == "company:manage:delete") {
            this.deleteShow = true
          }
          if (item.code == "company:manage:edit") {
            this.editShow = true
          }

        })
      }
    },

    SearchCompanyList(){
      this.pages.pageNo = 1
      this.queryTableData()
    },
    /**
     * 获取列表
     */
    async queryTableData() {
      this.loading = true;

      const { data: resData } = await this.$get("company/list", {
        params: {
          ...this.listParams,
          ...this.pages,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.tableData = resData.data;
      this.total = resData.page.count;
    },

    /**
     * 表格按钮点击
     */
    async handleClick(type, row = {}) {
      this.clickType = type;
      this.dialogVisible = true;

      if (type == "edit") {
        //编辑
        const { data: resData } = await this.$get(
          `company/info/${row.companyId}`,
          {
            headers: {
              isLoading: true,
            },
          }
        );

        if (resData.result != 200) return;
        // 注册  isEmpty
        let temp = {};
        if (!isEmpty(resData.data.provinceId)) {
          this.provinceIdData();
          temp.province = resData.data.provinceId;
        }
        if (!isEmpty(resData.data.cityId)) {
          this.cityData(resData.data.provinceId);
          temp.city = resData.data.cityId;
        }
        if (!isEmpty(resData.data.areaId)) {
          this.areaData(resData.data.cityId);
          temp.area = resData.data.areaId;
        }
        setTimeout(() => {
          this.params = { ...resData.data, ...temp };
        }, 450);
      } else if (type == "addNext") {
        //添加下一级
        this.params = { parentId: row.menu_id, parentMenuName: row.menu_name };
      } else {
        //添加
      }
    },
    /**
     * 编辑
     */
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认保存数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "add" || this.clickType == "addNext") {
            const { data: resData } = await this.$post(
              "company/info",
              this.params,
              {
                headers: {
                  isLoading: true,
                },
              }
            );

            if (resData.result != 200) return;

            this.queryTableData();

            this.dialogVisible = false;

            this.$message.success("添加成功!");
          } else {
            const { data: resData } = await this.$put(
              "company/info",
              this.params,
              {
                headers: {
                  isLoading: true,
                },
              }
            );

            if (resData.result != 200) return;

            this.queryTableData();

            this.dialogVisible = false;

            this.$message.success("修改成功!");
          }
        });
      });
    },
    /**
     * 删除
     */
    handleDelete(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const { data: resData } = await this.$delete(
          `company/info/${row.companyId}`,
          {
            headers: {
              isLoading: true,
            },
          }
        );

        this.queryTableData();

        this.$message.success("删除成功!");
      });
    },

    /**
     * 省列表
     */
    async provinceIdData() {
      this.loading = true;
      const { data: resData } = await this.$get("district/provice/list");
      this.loading = false;
      if (resData.result != 200) return;
      this.provinceList = resData.data;
    },
    /**
     * 市列表
     */
    async cityData(provinceId) {
      this.loading = true;
      const { data: resData } = await this.$get("district/city/list", {
        params: { provinceId },
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.cityList = resData.data;
    },
    /**
     * 区列表
     */
    async areaData(cityId) {
      this.loading = true;
      const { data: resData } = await this.$get("district/area/list", {
        params: { cityId },
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.areaList = resData.data;
    },

    changeProvince(value) {
      this.cityData(value);
      this.params.provinceId = value;
    },
    changeCity(value) {
      this.areaData(value);
      this.params.cityId = value;
    },
    changeArea(value) {
      this.params.areaId = value;
    },
    changeStatus(value) {
      this.params.status = parseInt(value);
    },

    /**
     *  分页长度改变
     */
    handleSizeChange(val) {
      this.pages.pageNo = 1;
      this.pages.pageSize = val;

      this.queryTableData();
    },

    /**
     *  下一页
     */
    handleCurrentChange(val) {
      this.pages.pageNo = val;

      this.queryTableData();
    },
  },
};
</script>
<style lang="scss" scoped="">
</style>